(function () {
  'use strict';

  var FREE_SHIPPING_CENTS = 100000;

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function imgUrl(url, size) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + size + '$1$3');
  }

  function buildShippingBar(totalCents) {
    var pct = Math.min(100, Math.round((totalCents / FREE_SHIPPING_CENTS) * 100));
    var msg;
    if (totalCents >= FREE_SHIPPING_CENTS) {
      msg = '🎉 Você ganhou <strong>frete grátis</strong>!';
    } else {
      var remaining = FREE_SHIPPING_CENTS - totalCents;
      msg = 'Faltam <strong>' + formatMoney(remaining) + '</strong> para <strong>frete grátis</strong>!';
    }
    return '<div class="vcd-shipping-bar">'
         +   '<p class="vcd-shipping-msg">' + msg + '</p>'
         +   '<div class="vcd-shipping-track">'
         +     '<div class="vcd-shipping-fill" style="width:' + pct + '%"></div>'
         +   '</div>'
         + '</div>';
  }

  function buildItems(items) {
    return items.map(function (item) {
      var src = imgUrl(item.featured_image && item.featured_image.url, '80x80_crop_center');
      var img = src
        ? '<img src="' + src + '" alt="' + (item.product_title || '') + '" width="72" height="72" loading="lazy">'
        : '<div class="vcd-item-img-placeholder"></div>';

      var opts = '';
      if (!item.product_has_only_default_variant && item.options_with_values) {
        item.options_with_values.forEach(function (o) {
          opts += '<span>' + o.name + ': ' + o.value + '</span> ';
        });
      }

      return '<div class="vcd-item">'
           +   '<div class="vcd-item-img">' + img + '</div>'
           +   '<div class="vcd-item-info">'
           +     '<a class="vcd-item-title" href="' + item.url + '">' + item.product_title + '</a>'
           +     '<div class="vcd-item-opts">' + opts + '</div>'
           +     '<div class="vcd-item-row">'
           +       '<div class="vcd-qty">'
           +         '<button type="button" class="vcd-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Diminuir">−</button>'
           +         '<span class="vcd-qty-val">' + item.quantity + '</span>'
           +         '<button type="button" class="vcd-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Aumentar">+</button>'
           +       '</div>'
           +       '<span class="vcd-item-price">' + formatMoney(item.final_line_price) + '</span>'
           +     '</div>'
           +   '</div>'
           +   '<button type="button" class="vcd-item-remove" data-key="' + item.key + '" aria-label="Remover item">×</button>'
           + '</div>';
    }).join('');
  }

  function buildFooter(cart) {
    return '<div class="vcd-footer">'
         +   '<div class="vcd-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>'
         +   '<div class="vcd-actions">'
         +     '<button type="button" class="vcd-checkout-btn vcd-checkout-form" id="vcd-checkout-btn">Finalizar compra</button>'
         +     '<button type="button" class="vcd-continue-shopping" id="vcd-continue-btn">Continuar<br>comprando</button>'
         +   '</div>'
         +   '<a href="/cart" class="vcd-view-cart">Ver carrinho completo</a>'
         + '</div>';
  }

  function render(cart) {
    var crt = document.getElementById('crt');
    if (!crt) return;

    var span = document.querySelector('.cartTop__count');
    if (span) span.textContent = cart.item_count + (cart.item_count === 1 ? ' Item' : ' Itens');

    var bubble = document.querySelector('[data-cart-count-bubble]');
    var count  = document.querySelector('[data-cart-count]');
    if (bubble && count) {
      count.textContent = cart.item_count || '';
      bubble.classList.toggle('hide', cart.item_count === 0);
    }

    crt.className = cart.item_count > 0 ? 'has-item' : '';

    if (cart.item_count === 0) {
      crt.innerHTML = buildShippingBar(0)
        + '<div class="vcd-empty">Seu carrinho está vazio.</div>';
      return;
    }

    crt.innerHTML = buildShippingBar(cart.total_price)
      + '<div class="vcd-scroll-area">' + buildItems(cart.items) + '</div>'
      + buildFooter(cart);
  }

  function open() {
    var drawer   = document.querySelector('.cartDrawer');
    var backdrop = document.querySelector('.cartBackdrop');
    if (!drawer) return;
    drawer.classList.add('vcd-open');
    if (backdrop) backdrop.classList.add('vcd-open');
    document.body.classList.add('vcd-body-lock');
  }

  function close() {
    var drawer   = document.querySelector('.cartDrawer');
    var backdrop = document.querySelector('.cartBackdrop');
    if (!drawer) return;
    drawer.classList.remove('vcd-open');
    if (backdrop) backdrop.classList.remove('vcd-open');
    document.body.classList.remove('vcd-body-lock');
  }

  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(console.error);
  }

  function addToCart(form) {
    var btn     = form.querySelector('[data-add-to-cart]');
    var btnText = btn && btn.querySelector('[data-add-to-cart-text]');
    var orig    = btnText ? btnText.innerHTML : null;

    if (btn) btn.setAttribute('aria-disabled', 'true');
    if (btnText) btnText.innerHTML = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status && json.status !== 200) throw new Error(json.description || json.message);
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        open();
      })
      .catch(function (err) {
        console.error('[ValentiCartDrawer]', err);
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-disabled');
        if (btnText && orig !== null) btnText.innerHTML = orig;
      });
  }

  function showVariantPicker(form) {
  var variants = JSON.parse(form.getAttribute('data-variants') || '[]');
  var title = form.getAttribute('data-product-title') || '';
  var idInput = form.querySelector('[name="id"]');

  var overlay = document.createElement('div');
  overlay.className = 'vcd-picker-overlay';

  var optionsHtml = variants.map(function(v) {
    var disabled = !v.available ? ' disabled' : '';
    return '<button type="button" class="vcd-picker-opt" data-variant-id="' + v.id + '"' + disabled + '>' + v.title + '</button>';
  }).join('');

  overlay.innerHTML =
    '<div class="vcd-picker-modal">' +
      '<div class="vcd-picker-title">' + title + '</div>' +
      '<div class="vcd-picker-label">Selecione o tamanho:</div>' +
      '<div class="vcd-picker-options">' + optionsHtml + '</div>' +
      '<button type="button" class="vcd-picker-confirm">Adicionar ao carrinho</button>' +
      '<button type="button" class="vcd-picker-cancel">Cancelar</button>' +
    '</div>';

  document.body.appendChild(overlay);

  var opts = overlay.querySelectorAll('.vcd-picker-opt');
  opts.forEach(function(opt) {
    opt.addEventListener('click', function() {
      opts.forEach(function(o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      idInput.value = opt.getAttribute('data-variant-id');
    });
  });

  overlay.querySelector('.vcd-picker-confirm').addEventListener('click', function() {
    var selected = overlay.querySelector('.vcd-picker-opt.selected');
    if (!selected) { alert('Selecione um tamanho'); return; }
    document.body.removeChild(overlay);
    addToCart(form);
  });

  overlay.querySelector('.vcd-picker-cancel').addEventListener('click', function() {
    document.body.removeChild(overlay);
  });
}

function bindButton(btn) {
  btn.addEventListener('click', function(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var form = btn.closest('form');
    if (!form) return;
    var hasVariants = form.getAttribute('data-has-variants') === 'true';
    if (hasVariants) {
      showVariantPicker(form);
    } else {
      addToCart(form);
    }
  }, true);
}

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-add-to-cart]').forEach(bindButton);

    document.addEventListener('click', function (evt) {
      var t = evt.target;
      var drawer = document.querySelector('.cartDrawer');
      if (drawer && drawer.classList.contains('vcd-open') && !drawer.contains(t)) {
        close();
        return;
      }
      if (
        t.classList.contains('closecart') ||
        (t.closest && t.closest('.closecart')) ||
        t.id === 'vcd-continue-btn'
      ) {
        close();
      }
    });

    document.addEventListener('keyup', function (evt) {
      if (evt.key === 'Escape' || evt.keyCode === 27) close();
    });

    document.addEventListener('click', function (evt) {
      if (evt.target.id === 'vcd-checkout-btn') {
        window.location.href = '/cart?goto_checkout=1';
      }
    });

    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('.vcd-qty-btn');
      if (btn) {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        if (!key || isNaN(qty)) return;
        updateQty(key, qty < 0 ? 0 : qty);
        return;
      }
      var rem = evt.target.closest && evt.target.closest('.vcd-item-remove');
      if (rem) updateQty(rem.getAttribute('data-key'), 0);
    });
  });

  window.ValentiCartDrawer = { open: open, close: close, render: render };
})();